export default __webpack_public_path__ + "static/media/topomap_eeg.3045ba52.webp";